/**
 * @desc 更新物流头程费用
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.UpdateHeadTripFeeRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/renewLogisticsHeadTripFee`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
